// @flow
import React from 'react';
import { resizeImage } from 'lib/common';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import './PartnerCard.scss';

type Props = {
  id: string,
  title: string,
  thumbnail: string,
  oneColumn?: boolean,
  urlSlug: string,
  partnerUrl: string,
};

const PartnerCard = ({ thumbnail, title, oneColumn, partnerUrl }: Props) => {
  const imgUrl = resizeImage(thumbnail, 200, 100);
  const link = `/products/tags/${partnerUrl}`;
  const style = {
    backgroundImage: `url(${imgUrl})`,
  };
  return (
    <div className={cx('PartnerCard', { 'one-column': oneColumn, empty: !thumbnail })}>
      {thumbnail && (
        <Link to={link} className={cx('thumbnail-wrapper')} style={style}>
          <div className="gray-mask" />
        </Link>
      )}
      <Link to={link} className="content-head">
        <h4>
          <div>{title}</div>
        </h4>
      </Link>
    </div>
  );
};

PartnerCard.defaultProps = {
  oneColumn: false,
};

export default PartnerCard;



// WEBPACK FOOTER //
// ./src/components/common/PartnerCard/PartnerCard.js